














































import LoginContainer from '@/components/authentication/login-container/LoginContainer.component'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {AuthenticationRequest, CompanyDetailsResponse, PasswordType, PortalType} from '@payroll/optimus-common'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Action, Getter, Mutation} from 'vuex-class'
import FeedbackComponent from '../../base/FeedbackComponent'

enum SmsSendingStatus {
  NOT_SENDING,
  SENDING,
  SENT,
  FAILED
}

@Component({
  components: {
            LoginContainer
        }
    })
    export default class LoginViaSmsComponent extends FeedbackComponent {

        @Action('authenticateViaSms', StoreNamespace.AUTHENTICATION) authenticateViaSms: any
        @Action('authenticateWithPassword', StoreNamespace.AUTHENTICATION) authenticateWithPassword: any
        @Mutation('setUserDetails', StoreNamespace.AUTHENTICATION) setUserDetails: any
        @Mutation('setTokens', StoreNamespace.AUTHORIZATION) setTokens: any
        @Mutation('setClientErrorsIndication', StoreNamespace.AUTHENTICATION) setClientErrorsIndication: any
        @Getter('idNumber', StoreNamespace.AUTHENTICATION) idNumber!: string
        @Getter('obfuscatedPhoneNum', StoreNamespace.AUTHENTICATION) phoneNum!: string
        @Getter('obfuscatedEmail', StoreNamespace.AUTHENTICATION) email!: string
        @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string
        @Getter('customerDetails', StoreNamespace.AUTHENTICATION) customerDetails!: CompanyDetailsResponse

        @Prop() password!: string
        @Prop() siteUrl!: string
        @Prop() browserInfo!: string

        private smsLoginAuth: AuthenticationRequest = {} as AuthenticationRequest
        private SmsSendingStatus = SmsSendingStatus
        private smsSending = SmsSendingStatus.NOT_SENDING
        private showReCaptcha = false

        mounted() {
            this.smsLoginAuth.managingCompany = this.mngCompanyName
            this.smsLoginAuth.portalType = PortalType.BACKOFFICE
            this.smsLoginAuth.idNumber = this.idNumber
            if (!this.password || !this.siteUrl || !this.browserInfo
                || !this.smsLoginAuth.managingCompany
                || !this.smsLoginAuth.portalType
                || !this.smsLoginAuth.idNumber) {
                this.$router.go(-1)
            }
            this.showReCaptcha = this.customerDetails.mode !== 'dev'
        }

        onLogin() {
            this.smsLoginAuth.passwordType = PasswordType.SMS_CODE
            this.authenticateViaSms({
                requestBody: this.smsLoginAuth,
                requestorCallback: this
            })
        }

        onError(messages: string[], code: number, requestName?: string) {
            if (code === 503) {
                this.$router.push({name: 'maintenance'})
            } else {
                this.serverErrorMessages = messages
                if (requestName === 'authenticateWithPassword') {
                    this.smsSending = SmsSendingStatus.FAILED
                }
            }
        }


        onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
            if (requestName === 'authenticate') {
              this.setClientErrorsIndication(data.clientErrorIndication)
              this.setUserDetails(data.userDetails)
                this.setTokens({
                    accessToken: data.accessToken,
                    refreshToken: data.refreshToken
                })
                setTimeout(() => {
                    if (data.userDetails.passwordExpired) {
                        this.$router.push({name: 'expired'})
                    } else {
                        this.$router.push({name: 'lobby'})
                    }
                }, 100)
            }
            if (requestName === 'authenticateWithPassword') {
                this.smsSending = SmsSendingStatus.SENT
            }
        }

        onSendSmsAgain(): void {
            if (this.showReCaptcha) {
                this.$recaptcha('login')
                    .then(response => this.sendSmsAgain(response))
                    .catch(() => this.smsSending = SmsSendingStatus.FAILED)
            } else {
                this.sendSmsAgain('')
            }
        }

        sendSmsAgain(response: string) {
            this.smsSending = SmsSendingStatus.SENDING
            this.smsLoginAuth.passwordType = PasswordType.PASSWORD
            this.smsLoginAuth.password = this.password
            this.smsLoginAuth.siteUrl = this.siteUrl
            this.smsLoginAuth.browserInfo = this.browserInfo
            this.smsLoginAuth.isMobile = this.isMobile
            this.smsLoginAuth.extraAuthenticationType = this.phoneNum ? PasswordType.SMS_CODE : PasswordType.EMAIL_CODE
            if (this.showReCaptcha) {
                this.smsLoginAuth.recaptchaResponse = response
            }
            this.authenticateWithPassword({
                requestBody: this.smsLoginAuth,
                requestorCallback: this
            })
        }


    }
